'use strict' ;
angular.module("Khayrokom" ,  [
	'ui.router' ,
	'ui.bootstrap' ,
	'angular-loading-bar' ,
	'ui-notification' ,
	'ngCookies',
	'ngAnimate',
	'pascalprecht.translate',
	'oc.lazyLoad',
    'youtube-embed',
	'infinite-scroll',
	'ngSanitize',
	'720kb.socialshare',
    'ng.deviceDetector',
	'countUpModule'
])

.constant("baseURL","https://khairokom.gplanet.tech/")
	.directive('showData', ['$compile', function ( $compile ) {
        return {
            scope: true,
            link: function ( scope, element, attrs ) {
                var el;

                attrs.$observe( 'template', function ( tpl ) {
                    if ( angular.isDefined( tpl ) ) {
                        // compile the provided template against the current scope
                        el = $compile( tpl )( scope );

                        // stupid way of emptying the element
                        element.html("");

                        // add the template content
                        element.append( el );
                    }
                });
            }
        };
    }])
	.run(['$rootScope', function ($rootScope) {
		$rootScope.headerStuff = require('../../views/header.html');
    }])
/*For anyone that wants a workaround (not recommended, though),
you can globally silence unhandled promise rejections like this —*/
.config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);




// WEBPACK FOOTER //
// ./js/app/app.js